export const transformFeaturedCollection = dto => ({
  id: dto.id,
  title: dto.title,
  discount: dto.discount,
  items: dto.items,
  isActive: dto.is_active,
  humanizedTimeLeft: dto.humanized_time_left || undefined
});